import { get, patch, post } from './request';
import { AxiosError } from 'axios';
import { ActivePolicy } from './bond-insurance-policy';

export type claimFiltersType = {
  page: number;
  estateId?: string | null;
  insurerId?: string | null;
  claimEstateStatus?: string | null;
  claimPropertyStatus?: string | null;
  start?: Date | null;
  end?: Date | null;
  responsibleId?: string | null;
  estateResponsibleId?: string | null;
  address?: string | null;
  propertyCode?: string | null;
  name?: string | null;
  onlyUnread: boolean | null;
  userId?: string | null;
  isReport?: boolean | null;
};
interface IGetClaims {
  id?: string;
  filters?: claimFiltersType;
  isReport?: boolean;
  sortColumn?: string | null;
  sortDirection?: string | null;
}

export const getClaims = async ({
  id,
  filters,
  sortColumn,
  sortDirection
}: IGetClaims) => {
  let url = id ? `/claims/${id}` : '/claims';

  let query = '';

  if (filters) {
    Object.entries(filters).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  if (sortColumn) {
    query += `sortColumn=${encodeURIComponent(sortColumn)}&`;
  }
  if (sortDirection) {
    query += `sortDirection=${encodeURIComponent(sortDirection)}&`;
  }

  if (query.endsWith('&')) {
    query = query.slice(0, -1);
  }

  url = query ? `${url}?${query}` : url;

  const response = await get(url);

  return response;
};

export async function getAllDashboards() {
  const response = await get('/dashboard');

  return response;
}

export const getClaimsReport = async ({
  filters
}: IGetClaims): Promise<number | undefined> => {
  let query = '';

  if (filters) {
    filters.isReport = true;

    Object.entries(filters).forEach((map: [string, any]) => {
      if (map[1]) {
        query += `${map[0]}=${map[1]}&`;
      }
    });
  }

  try {
    const response = await get(`/claims/report-excel?${query}`);
    return response.status;
  } catch (error) {
    const { response } = error as AxiosError;
    return response?.status;
  }
};

export async function getClaimsByClaimResponsible(
  claimResponsibleId: string,
  estates: string[]
) {
  const estatesJoined = estates.join(',');
  const response = await get(
    `/claims/by-responsible-and-estates/${claimResponsibleId}/${estatesJoined}`
  );
  return response;
}

export async function transferClaimsResponsibleById(
  oldClaimResponsibleId: string,
  newClaimResponsibleId: string,
  estates: string[],
  shouldTransferClaims: boolean
) {
  const estatesJoined = estates.join(',');
  return patch(`/claims/transfer-estates-claim-responsible`, {
    oldUser: oldClaimResponsibleId,
    newUser: newClaimResponsibleId,
    estatesIds: estatesJoined,
    shouldTransferClaims
  });
}

export async function updateClaimEstateResponsible(
  claimId: string,
  estateResponsibleId: string | null
) {
  return patch(`/claims/${claimId}/estate-responsible`, {
    estateResponsibleId
  });
}

export const getClaimByPolicyNumber = async (policyNumber: string) => {
  return await get(`/claims/check-policy-number/${policyNumber}`);
};



export const getActivePoliciesByTenantDocument = async (
  document: string
): Promise<ActivePolicy[]> => {
  // Remove máscara do documento
  const cleanDocument = document.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
  return await get(`/claims/check-policies-by-document/${cleanDocument}`);
};

export const getClaimByTenantDocument = async (document: string) => {
  // Remove máscara do documento
  const cleanDocument = document.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
  return await get(`/claims/check-claim-by-tenant-document/${cleanDocument}`);
};

export const getClaimByAddress = async (body: any) => {
  return await post(`/claims/check-address`, body);
};
